import { ref, Ref } from 'vue'

export interface CollapseState {
  visible: Ref<boolean>
  toggle: () => void
  show: () => void
  hide: () => void
}

/**
 * This is a simple composable that manages the state (show, hide) of a collapse component.
 * @param {boolean} initialState - The initial state of the collapse component.
 * @returns {CollapseState} An object with the following properties:
 * - visible: A ref that tracks the visibility of the collapse component.
 * - toggle: A function that toggles the visibility of the collapse component.
 * - show: A function that shows the collapse component.
 * - hide: A function that hides the collapse component.
 */
export default function useCollapse(initialState = false): CollapseState {
  const visible = ref(initialState)

  const toggle = (): void => {
    visible.value = !visible.value
  }

  const show = (): void => {
    visible.value = true
  }

  const hide = (): void => {
    visible.value = false
  }

  return {
    visible,
    toggle,
    show,
    hide,
  }
}
